// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const warehouse = defineModel({
  id: "warehouse",
  batchId: "future",
  name: "Warehouse",
  tags: ["building","warehouse","low-poly","age-of-mcp","future"],
  summary: "A big storehouse with cargo doors — buffers bulk goods between chains.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.94, 0.14, 1.94), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.94, 0.14, 1.94), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.5, 1.1), color: "#9a9486", position: [0, 0.39, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#6f6a5e", position: [-0.75, 0.39, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#6f6a5e", position: [0.75, 0.39, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#6f6a5e", position: [-0.75, 0.39, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#6f6a5e", position: [0.75, 0.39, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.85, 0.45, -0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.85, 0.45, -0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.85, 0.45, 0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.85, 0.45, 0.85] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.94, 0.14, 1.94), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 1, 1.1), color: "#9a9486", position: [0, 0.64, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 1, 0.1), color: "#6f6a5e", position: [-0.75, 0.64, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 1, 0.1), color: "#6f6a5e", position: [0.75, 0.64, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 1, 0.1), color: "#6f6a5e", position: [-0.75, 0.64, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 1, 0.1), color: "#6f6a5e", position: [0.75, 0.64, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [-0.85, 0.75, -0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [0.85, 0.75, -0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [-0.85, 0.75, 0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.5, 4), color: "#6b4a26", position: [0.85, 0.75, 0.85] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.94, 0.14, 1.94), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 1, 1.1), color: "#9a9486", position: [0, 0.64, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 1, 0.1), color: "#6f6a5e", position: [-0.75, 0.64, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 1, 0.1), color: "#6f6a5e", position: [0.75, 0.64, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 1, 0.1), color: "#6f6a5e", position: [-0.75, 0.64, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 1, 0.1), color: "#6f6a5e", position: [0.75, 0.64, 0.55] },
      { geometry: new THREE.BoxGeometry(1.6, 0.07, 0.657343), color: "#4a5258", position: [0, 1.32, 0.275], rotation: [0.579564, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.6, 0.07, 0.657343), color: "#4a5258", position: [0, 1.32, -0.275], rotation: [-0.579564, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.62, 0.08, 0.08), color: "#33393d", position: [0, 1.5, 0] },
      { geometry: new THREE.BoxGeometry(0.94, 0.1, 0.08), color: "#3c4146", position: [0, 0.92, 0.57] },
      { geometry: new THREE.BoxGeometry(0.42, 0.78, 0.06), color: "#5b6166", position: [-0.23, 0.51, 0.58] },
      { geometry: new THREE.BoxGeometry(0.42, 0.78, 0.06), color: "#5b6166", position: [0.23, 0.51, 0.58] },
      { geometry: new THREE.BoxGeometry(0.88, 0.05, 0.07), color: "#3c4146", position: [0, 0.66, 0.585] },
      { geometry: new THREE.BoxGeometry(0.88, 0.05, 0.07), color: "#3c4146", position: [0, 0.36, 0.585] },
      { geometry: new THREE.BoxGeometry(0.98, 0.2, 0.26), color: "#6f6a5e", position: [0, 0.24, 0.7] },
      { geometry: new THREE.BoxGeometry(0.6, 0.05, 0.5), color: "#a9763f", position: [0, 0.16, 1.05], rotation: [0.45, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.26, 0.26), color: "#a9763f", position: [-0.62, 0.27, 0.66] },
      { geometry: new THREE.BoxGeometry(0.22, 0.22, 0.22), color: "#8f6234", position: [-0.6, 0.51, 0.64] },
      { geometry: new THREE.BoxGeometry(0.26, 0.26, 0.26), color: "#a9763f", position: [-0.62, 0.27, 0.36] },
      { geometry: new THREE.SphereGeometry(0.11, 6, 5), color: "#c7b27a", position: [0.6, 0.24, 0.62], scale: [1, 0.8, 1.1] },
      { geometry: new THREE.SphereGeometry(0.11, 6, 5), color: "#bba76e", position: [0.74, 0.24, 0.5], scale: [1, 0.8, 1.1] },
      { geometry: new THREE.SphereGeometry(0.1, 6, 5), color: "#c7b27a", position: [0.66, 0.38, 0.56], scale: [1, 0.8, 1.1] },
    ] },
  ],
  animations: [],
});
